<div class="container sms002">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">
    <!-- コンテンツエリア -->
    <div class="content-area sms002-content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <!-- 企業ロゴ・住所 -->
          <div class="address-area">
            <div class="column-logo">
              <img class="main-logo" src="assets/images/main_logo.png" />
            </div>
            <div class="column-address">
              <mat-label class="address">{{lblAddress01}}</mat-label>
              <mat-label class="telephone">{{lblTelephone01}}{{lblTelephone02}}</mat-label>
            </div>
          </div>
          <br>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
          </div>
          <br>

          <!-- 氏名（漢字） -->
          <div>
            <mat-form-field appearance="standard" class="disp-data-field">
              <mat-label>{{lblNameSei}}</mat-label>
              <input matInput formControlName="txtNameSei" class="disp-data-text" />
            </mat-form-field>
            <mat-form-field appearance="standard" class="disp-data-field">
              <mat-label>{{lblNameMei}}</mat-label>
              <input matInput formControlName="txtNameMei" class="disp-data-text" />
            </mat-form-field>
          </div>

          <!-- 氏名（カナ） -->
          <div>
            <mat-form-field appearance="standard" class="disp-data-field">
              <mat-label>{{lblKanaSei}}</mat-label>
              <input matInput formControlName="txtKanaSei" class="disp-data-text" />
            </mat-form-field>
            <mat-form-field appearance="standard" class="disp-data-field">
              <mat-label>{{lblKanaMei}}</mat-label>
              <input matInput formControlName="txtKanaMei" class="disp-data-text" />
            </mat-form-field>
          </div>

          <!-- 生年月日 -->
          <div>
            <mat-form-field appearance="standard" class="disp-data-field">
              <mat-label>{{lblBirthday}}</mat-label>
              <input matInput formControlName="txtBirthday" class="disp-data-text" />
            </mat-form-field>
          </div>

          <!-- 物件名 -->
          <div>
            <mat-form-field appearance="standard" class="disp-bldg-field">
              <mat-label>{{lblBldgName}}</mat-label>
              <input matInput formControlName="txtBldgName" class="disp-data-text" />
            </mat-form-field>
          </div>

          <!-- 部屋番号 -->
          <div>
            <mat-form-field appearance="standard" class="disp-data-field">
              <mat-label>{{lblRoomNo}}</mat-label>
              <input matInput formControlName="txtRoomNo" class="disp-data-text" />
            </mat-form-field>
          </div>

          <!-- 契約開始日 -->
          <div>
            <mat-form-field appearance="standard" class="disp-data-field">
              <mat-label>{{lblKeiyakuDate}}</mat-label>
              <input matInput formControlName="txtKeiyakuDate" class="disp-data-text" />
            </mat-form-field>
          </div>

          <br>
          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button (click)="executeClick()" tabindex="1">{{lblBtnSend}}</button>
          </div>

        </div>
      </form>

    </div>

  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button (click)="backClick()" accesskey="q" tabindex="2">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
